module.exports = "/_next/static/images/cars24-53e2727ade1110867d0479fa6e0893c5.png";